import { Center, Text } from '@chakra-ui/react';
import { Dialog } from '@halo/ui-react';
import type { ReactNode } from 'react';
import { CloseIcon } from '@halo/ui-chat-react';

export interface HeaderProps {
  title: ReactNode;
  onClose?: () => void;
}

const Header = ({ title, onClose }: HeaderProps) => {
  return (
    <Dialog.Header justifyContent="space-between" pt="5" pb="4">
      <Text fontSize="md" fontWeight="semibold">
        {title}
      </Text>
      {!!onClose && (
        <Center cursor="pointer" onClick={onClose}>
          <CloseIcon />
        </Center>
      )}
    </Dialog.Header>
  );
};

export { Header };
